import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, requireAuth } from '@utils/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(requireAuth))
